module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"error-msg":"Zugriff nicht erlaubt","btn-go-home":"Home"},"fr":{"error-msg":"Accès non autorisé","btn-go-home":"Accueil"},"it":{"error-msg":"Accesso non consentito","btn-go-home":"Home"}}')
  delete Component.options._Ctor
}
